export default __webpack_public_path__ + "media/images/react_icons/property/smart_tv-23b67b87b295fcc4a3750f9a7e8fc60c.svg";